const adaStyle = `
<style>
.show-button {
  display: block !important;
}

.hide-button {
  display: none !important;
}

/*
  You can position the custom Ada button in the lower right corner
  */
#custom-ada-chat-button {
  position: fixed;
  padding: 10px;
  right: 20px;
  bottom: 10px;
}

/*
  By default we hide the Ada button
*/
#ada-button-frame {
  display: none;
}
</style>`;

const adaScript = `
const liveChatId = 'fabfitfun.com-ada';
const liveChatButtonSelector = '#custom-ada-chat-button';
let liveChatStarted = false;
let liveChatEnded = false;

function setLastChatOpened(name) {
  sessionStorage.setItem('lastChatOpened', name);
}

function hideAda() {
  window.adaEmbed.getInfo().then((info) => {
    if (info.isChatOpen) {
      window.adaEmbed.toggle();
      const adaButton = document.querySelector('#ada-button-frame');
      adaButton.classList.remove('show-button');
    }
  });
}

function displayAda() {
  window.adaEmbed.getInfo().then((info) => {
    if (!info.isChatOpen) {
      const adaButton = document.querySelector('#ada-button-frame');
      window.adaEmbed.toggle();
      adaButton.classList.add('show-button');
      setLastChatOpened('ada');
    }
  });
}

function hideLiveChatButton(data, eventInfo) {
  if (!liveChatStarted || liveChatEnded) {
    const liveChatButton = document.querySelector(liveChatButtonSelector);
    liveChatButton.classList.add('hide-button');
    displayAda();
  }
}

function handleLiveChatState(data, eventInfo) {
  const liveChatState = data.state;
  if (liveChatState === 'ended' || liveChatState === 'postChat' || liveChatState === 'applicationEnded') {
    liveChatEnded = true;
  }
}

function checkLastChatOpened() {
  let lastChatOpened = sessionStorage.getItem('lastChatOpened');

  if (lastChatOpened !== 'ada') {
    const adaButton = document.querySelector("#ada-button-frame");
    adaButton.classList.add("show-button");
  }
}

function startLiveChat(handoffParams) {
  hideAda();

  lpTag.taglets.rendererStub.click(liveChatId, {});
  liveChatStarted = true;
  setLastChatOpened('ada');

  const userInfo = {
    "type": "personal",
    "personal": {
      "firstName": handoffParams.firstName,
      "contacts": [{
        "email": handoffParams.email,
      }],
    },
  };
  lpTag.sdes.send(userInfo);
}

  window.adaSettings = {
    adaReadyCallback: () => {
      const adaButton = document.querySelector('#ada-button-frame');
      checkLastChatOpened();
    },
    eventCallbacks: {
      "custom_handoff": event => {
        const handoffParams = {
          firstName: event.user_data.global.firstname,
          email: event.user_data.global.email,
        };

        startLiveChat(handoffParams);
      }
    }
  }`;

export { adaStyle, adaScript };
